var map = {
	"./": 93038,
	"./akros.png": 79822,
	"./allianz.svg": 3531,
	"./americanexpress.svg": 21742,
	"./barclays.svg": 88533,
	"./bcc.svg": 84073,
	"./bim.png": 511,
	"./bnl.svg": 47188,
	"./bper.png": 23720,
	"./bpm.svg": 93882,
	"./carige.png": 39903,
	"./cartalis.png": 75230,
	"./cento.png": 61244,
	"./chebanca.svg": 11362,
	"./cinque.svg": 17042,
	"./civibank.png": 83728,
	"./compass.png": 92446,
	"./credem.svg": 41306,
	"./creditagricole.svg": 2425,
	"./creval.png": 93854,
	"./default_logo.png": 1296,
	"./default_logo.svg": 57177,
	"./delsud.png": 53435,
	"./depobank.png": 515,
	"./desio.svg": 39598,
	"./euromobiliare.svg": 13134,
	"./farbanca.png": 73399,
	"./fideuram.svg": 48731,
	"./findomestic.png": 22934,
	"./fineco.svg": 54535,
	"./friulandria.png": 56240,
	"./fucino.png": 57317,
	"./galileo.png": 30633,
	"./generali.svg": 9599,
	"./guber.png": 2354,
	"./hello.svg": 84131,
	"./hype.svg": 42781,
	"./ibl.png": 4341,
	"./ifis.png": 66118,
	"./illimity.png": 36593,
	"./index": 93038,
	"./index.jsx": 93038,
	"./ing.svg": 64257,
	"./intesa.svg": 83904,
	"./iwbank.png": 58046,
	"./mediobanca.png": 17750,
	"./mediolanum.svg": 50267,
	"./mps.svg": 28245,
	"./n26.svg": 85010,
	"./nexi.svg": 55303,
	"./passadore.svg": 70132,
	"./piemonte.png": 53478,
	"./poste.svg": 13763,
	"./postepay.svg": 58902,
	"./santander.png": 67676,
	"./sardegna.svg": 55447,
	"./sella.svg": 56258,
	"./sondrio.svg": 92964,
	"./spoleto.png": 66643,
	"./ubi.svg": 46049,
	"./ubs.svg": 4762,
	"./unicredit.svg": 53029,
	"./unipol.png": 21560,
	"./widiba.svg": 91797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22616;